import { useQuery } from "@tanstack/react-query";
import { getFormGenerationDashboard } from "../services/formGenerationUsageApi";
import {
  FormGenerationQueryParams,
  FormGenerationDashboard,
} from "../types/form-generation-usage.types";

const FORM_GENERATIONS_QUERY_KEY = "formGenerationsDashboard";

interface UseFormGenerationsDashboardOptions {
  dateFrom?: string;
  dateTo?: string;
  enabled?: boolean;
}

export const useFormGenerationsDashboard = (
  options: UseFormGenerationsDashboardOptions = {}
) => {
  const { dateFrom, dateTo, enabled = true } = options;

  const queryParams: FormGenerationQueryParams = {};
  if (dateFrom) queryParams.dateFrom = dateFrom;
  if (dateTo) queryParams.dateTo = dateTo;

  return useQuery<FormGenerationDashboard, Error>({
    queryKey: [FORM_GENERATIONS_QUERY_KEY, dateFrom, dateTo],
    queryFn: async () => {
      const response = await getFormGenerationDashboard(queryParams);
      return response.data;
    },
    enabled,
    staleTime: 5 * 60 * 1000, // 5 minutes
    gcTime: 30 * 60 * 1000, // 30 minutes
    retry: 3,
    retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 10000),
  });
};

export default useFormGenerationsDashboard;
